<template>
  <div class="page">
    <el-table stripe :data="tableData" border
              style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
      <el-table-column type="index"
                       :width="pagination.endIndex >= 1000 ? 80:50" align="center"
                       :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column
          prop="typeName"
          label="类别"
          align="center"
          min-width="110"
          show-overflow-tooltip
          sortable="typeName"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.typeName">{{ scope.row.typeName }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="名称"
          align="center"
          min-width="110"
          show-overflow-tooltip
          sortable="name"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name">{{ scope.row.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="desc"
          label="简述"
          align="center"
          min-width="90"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.desc">{{ scope.row.desc }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="repairLevel"
          label="维修等级"
          align="center"
          min-width="90"
          show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.repairLevel">{{ scope.row.repairLevel.title}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column class-name="operation" label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="edit($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="dark" content="移除" placement="top" :open-delay="300">
            <i @click="del($event, scope.row)" class="iconfont icon-yichu"></i>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="search"
    ></pagination>
    <myDialog
        ref="editDialog"
        :title="dialogTitle"
        @submitData="submitData"
        @dialogClose="dialogClose"
        width="450px"
    >
      <template slot="content">
        <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
          <el-form-item label="类别" size="small" prop="typeCode">
            <el-select
              v-model="form.typeCode"
              @change="changeType"
              placeholder="选择类别"
              filterable
              clearable
              :disabled="dialogTitle === '编辑'"
            >
              <el-option
                v-for="(item, index) in typeNameList"
                :key="index"
                :label="item.typeName"
                :value="item.typeCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" size="small" prop="name">
                <el-input v-model="form.name" placeholder="名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="简述" size="small" prop="desc">
            <el-input v-model="form.desc" placeholder="简述" clearable></el-input>
          </el-form-item>
          <el-form-item label="维修等级" size="small" v-if="form.typeCode == 1">
            <el-select
              v-model="form.repairLevel"
              placeholder="选择维修等级"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in repairLevelList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiRepairCodeAdd,
  apiRepairCodeUpdate,
  apiRepairCodeSearch,
  apiRepairCodeDel,
  apiGetTypeList,
  apiRepairLevel,
} from "@/api/plantSetting.js";

export default {
  components: {
    pagination,
    myDialog
  },
  props: {
    searchRepairForm: {
      type: Object
    }
  },
  data() {
    return {
      dialogTitle: '',
      tableData: [],
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      typeNameList: [],
      repairLevelList: [],
      //选中类别对象
      typeName:{},
      form: {},
      formRules: {
        name: [
          {required: true, message: "名称不能为空！", trigger: "blur"},
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ],
        typeCode: [
          {required: true, message: "类别不能为空！", trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    changeType(code) {
      this.typeName= this.typeNameList.find(item => item.typeCode == code)  
      if (code != 1) {
        this.$set(this.form, 'repairLevel', null);
      }
    },
    async getTypeNameList(){ 
      const res = await apiGetTypeList({
        
      });
      if (res.code == 0) {
        this.typeNameList = res.data;
      }
    },
    async getRepairLevelList() {
      const res = await apiRepairLevel();
      if (res.code == 0) {
        this.repairLevelList = res.data;
      }
    },
    // 表格数据
    async search(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiRepairCodeSearch({
        ...this.searchRepairForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback)
        this.callback();
      }
    },
    // 表格数据排序
    sortChange({prop, order}) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.search();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.search();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.search();
    },
    openAdd() {
      this.dialogTitle = '新增'
      this.$refs.editDialog.dialogVisible = true;
    },
    edit(e, row) {
      this.dialogTitle = '编辑'
      this.$refs.editDialog.dialogVisible = true;
      this.form = {
        id: row.id,
        typeCode:row.typeCode,
        typeName:row.typeName,
        name: row.name,
        desc: row.desc,
        repairLevel: row.repairLevel ? row.repairLevel.code : null,
      };
    },
    // 对话框提交
    submitData() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.form.id) {
            apiRepairCodeUpdate(this.form).then(res => {
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            })
          } else {
            let res = await apiRepairCodeAdd({
              ...this.form,
              typeName:this.typeName.typeName
            });
              if (res.code === 0) {
                this.$refs.editDialog.dialogVisible = false
                this.currentChange(1)
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            }
        } else {
          return false;
        }
      });
    },
    del(e, row) {
      this.$confirm(`确认移除${row.name}吗？`, "维修方式移除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        apiRepairCodeDel({
          id: row.id
        }).then(res => {
          if (res.code === 0) {
            this.currentChange(this.pagination.currentPage)
            this.$message({
              type: "success",
              message: "移除成功"
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        })
      })
    },
    callback() {
      this.getTypeNameList();
      this.getRepairLevelList();
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.form.resetFields();
      this.form = {};
    },
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;

  .refreshBox {
    /deep/ .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-input {
        width: 92%;
      }

      .icon {
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>